import template from './performance_cycle_search.html';
import tr from '../../lib/default-translator.js';

class CycleSearchComponentViewModel
{
	constructor (params)
	{
		this.params = params;

		this.cycles = ko_helper.safe_observableArray();
		this.selected_cycle = ko_helper.safe_observable(params.selected_cycle || '');
		this.search_string = ko.observable('');

		// Computed observable for dynamically updating the placeholder
		this.placeholder_text = ko.pureComputed(() => {
			return this.selected_cycle() != null ? this.selected_cycle().cycle_name : tr("Search performance cycle...");
		});

		this.search_string.subscribe((val) => {
			this.updateData();
		});
	}

	async init()
	{
		await this.updateData();
	}

	async updateData()
	{
		let options = {
			table: 'v_performance_cycles',
			schema: 'perfm_manage',
			limit: 10000,
			filter_join: 'OR',
			filter: []
		};

		if (this.search_string() && this.search_string() != '')
		{
			options.filter.push({
				field: 'cycle_name',
				operand: 'ILIKE',
				value: `%${this.search_string()}%`,
			});

			let result = await Grape.fetches.getJSON('/api/record', options);
			if (result.status != 'ERROR')
				if (result.records != null)
					this.cycles(result.records);
		}
		else
			this.cycles([]);
	}

	cycle_click (selected)
	{
		this.selected_cycle(selected);
		console.log('SELECTED CYCLE:', this.selected_cycle());
		this.search_string('');
	}

	clear_selected_option ()
	{
		this.selected_cycle(null);
		this.search_string('');
	}
}

export default {
	name: 'cycle_search_component',
	viewModel: CycleSearchComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/cycle_search_component'
};
